import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-1 w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-6 h-6 text-white animate-spin fill-blue-600",
  viewBox: "0 0 100 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
    fill: "currentFill"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-6 h-6 text-white animate-spin fill-blue-600",
  viewBox: "0 0 100 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
    fill: "currentFill"
  })
], -1)
const _hoisted_4 = { class: "flex justify-between items-center space-x-1" }
const _hoisted_5 = { class: "table table-hover" }
const _hoisted_6 = { class: "sticky -top-2 bg-slate-200 dark:bg-primary text-black dark:text-white z-50" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5 text-white animate-spin fill-blue-600",
  viewBox: "0 0 100 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
    fill: "currentFill"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, "Loading...", -1)
const _hoisted_10 = {
  key: 0,
  class: "grid grid-cols-2 gap-4 w-full bg-slate-200 dark:bg-darkmode-200 rounded-md"
}
const _hoisted_11 = { class: "p-0.5" }

import {
  watch,
  reactive,
  watchEffect,
  computed,
  onMounted,
  ref,
  toRefs,
  withDefaults,
  onBeforeMount,
  nextTick
} from "vue";
import MultipleSelect from "./MultipleSelect.vue";
import TextField from "./TextField.vue"
import Icon from "./Icon.vue"
// import LoadingIcon from "./Icon.vue"

interface Props {
  modelValue: any;
  label: string;
  placeholder?: string;
  items?: any[];
  itemText?: string;
  itemValue?: string;
  itemsPerPage?: number;
  header?: any[];
  rule?: any;
  multiple?: boolean;
  tag?: string;
  searchDelay: number;
  resultObj?: boolean;
  infoEnable?: boolean;
  disabled: boolean;
  updatedItem: any | null;
  isClicked?: boolean;
  refKey: string;
  focusSearch: boolean,
  isLoading?: boolean;
}

interface LoadOption {
  page: number;
  itemsPerPage: number;
  search: string;
  callback(items: any[], totalItems: number): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {},
    label: { default: "" },
    placeholder: {},
    items: { default: () => [] },
    itemText: { default: "text" },
    itemValue: { default: "value" },
    itemsPerPage: { default: 10 },
    header: { default: () => [] },
    rule: {},
    multiple: { type: Boolean, default: false },
    tag: {},
    searchDelay: { default: 1000 },
    resultObj: { type: Boolean, default: false },
    infoEnable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    updatedItem: { default: null },
    isClicked: { type: Boolean, default: false },
    refKey: {},
    focusSearch: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "update:isClicked", "load"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const {
  modelValue,
  label,
  placeholder,
  items,
  itemText,
  itemValue,
  itemsPerPage,
  multiple,
  header,
  rule,
  tag,
  resultObj,
  searchDelay,
  infoEnable,
  disabled,
  updatedItem,
  isClicked,
  refKey,
  isLoading,
  focusSearch
} = toRefs(props);

const show = ref<boolean>(false);
const search = ref<any>();
const isSearch = ref<boolean>(false);
const selected = ref<boolean>();
const serverItems = ref<any[]>([]);
const loading = ref<boolean>(false);
const loadTimer = ref<any>();
const searchTimer = ref<any>();

const modelText = ref<any>();

const isServerSideRendering = ref<boolean>();

const _icon = {
  name: `${show.value ? "ChevronUp" : "ChevronDown"}`,
  color: "white",
  darkColor: "white",
  front: false,
  back: true,
};

const options = {
  page: 0,
  itemsPerPage: itemsPerPage.value,
  totalItems: 0,
  search: "",
};

const _modelValue = computed({
  get() {
    return modelValue.value;
  },
  set(val) {
    emit("update:modelValue", val);
  },
});

const _isClicked = computed({
  get() {
    return isClicked.value;
  },
  set(val) {
    emit("update:isClicked", val);
  },
});

watch(() => _isClicked.value, (val) => {
  if (val) {
    const event = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    let idKey = "clicked-" + refKey.value
    let isClickedElement = document.getElementById(idKey) as HTMLElement
    isClickedElement.dispatchEvent(event);
    // nextTick(() => {
    //   _isClicked.value = false
    //   console.log('_isClicked next',_isClicked.value);
    // })

  }
})

const _headerData = ref<any[]>([]);

const setValue = (obj: any) => {
  if (obj && header.value.length > 0) {
    _headerData.value = [];

    header.value.forEach((x: any) => {
      for (const [key, value] of Object.entries(obj)) {
        if (key === x.value) {
          let findObj: any = {
            text: x.text,
            value: value,
            format: x.format,
          };
          _headerData.value.push(findObj);
        }
      }
    });
  }
};

const clean = () => {
  search.value = "";
  options.page = 0;
};

const _placeholder = computed(() => {
  return loading.value ? 'Loading...' : placeholder?.value === undefined ? label.value : placeholder.value;
});

const _serverSideRendering = computed(() => {
  return !(items.value && items.value.length > 0);
});

const _items = computed(() => {
  if (_serverSideRendering.value) {
    isServerSideRendering.value = true;
    return serverItems.value || [];
  } else {
    isServerSideRendering.value = false;
    if (itemText.value === "text" && itemValue.value === "value") {
      let cusList = items.value.map((m: any) => {
        return { text: m, value: m };
      });
      return (
        (!selected.value && search.value?.trim()?.length > 0
          ? cusList.filter((x: any) =>
            x[itemText.value]
              ?.toString()
              ?.toLowerCase()
              ?.includes(search.value?.toString()?.toLowerCase())
          )
          : cusList) || []
      );
    } else {
      return (
        (!selected.value && search.value?.trim()?.length > 0
          ? items.value.filter((x) =>
            x[itemText.value]
              ?.toString()
              ?.toLowerCase()
              ?.includes(search.value?.toString()?.toLowerCase())
          )
          : items.value) || []
      );
    }
  }
});

watch(
  () => show.value,
  (val) => {
    if (!val) {
      setText();
    }
  },
  { deep: true }
);

watch(
  () => _modelValue.value,
  (val) => {
    if (val) {
      setText();
    } else {
      setText();
      _headerData.value = [];
    }
  },
  { deep: true }
);

watch(
  () => search.value,
  (val) => {
    selected.value = false;
    if (_serverSideRendering.value) {
      clearTimeout(searchTimer.value);
      searchTimer.value = setTimeout(() => {
        if (val) {
          isSearch.value = true;
          options.page = 0;
          options.search = val;
          serverItems.value = [];
          loadMore();
        } else {
          isSearch.value = false;
          options.page = 0;
          options.search = val;
          serverItems.value = [];
          loadMore();
        }
      }, searchDelay.value);
    }
  },
  { deep: true, immediate: true }
);

watch(
  () => _items.value,
  (val) => {
    if (val?.length > 0 && updatedItem.value) {
      if (!resultObj.value) {
        let findItem = val?.find((x) => x[itemValue.value] === _modelValue.value[itemValue.value])?.[itemText.value];
        if (!findItem) {
          _items.value.push(updatedItem.value);
          setText();
        }
      } else {
        let findItem = val?.find((x: any) => x[itemValue.value] === _modelValue.value[itemValue.value]);
        if (!findItem) {
          _items.value.push(updatedItem.value);
          setText();
        }
      }
    }

    //   if(val.length === 1 && !isSearch.value){
    //     if(resultObj.value){
    //       _modelValue.value = val[0];
    //     }
    //     else{
    //       _modelValue.value = val[0][itemText.value];
    //     }
    // }

  }
);

const focusSearchRef = ref<HTMLElement>();

onMounted(() => {
  // if(focusSearch.value){
  //   nextTick(() => focusSearchRef.value?.focus())
  // }
  if (isServerSideRendering) {
    loadMore();
  }
  setText();
});

const _list = ref<any[]>([]);
const select = (item: any) => {
  if (multiple.value) {
    if (resultObj.value !== true) {
      _list.value.push(item[itemValue.value]);
      _modelValue.value = _list.value;
    } else {
      _list.value.push(item);
      _modelValue.value = _list.value;
    }
  } else {
    if (resultObj.value !== true) {
      _modelValue.value = item[itemValue.value];
    } else {
      _modelValue.value = item;
    }

    if (header.value.length > 0) {
      setValue(item);
    }
  }

  show.value = !show.value;
};

const getText = (val: any) => {
  if (resultObj.value !== true) {
    return _items.value.find((x) => x[itemValue.value] === val)?.[
      itemText.value
    ];
  } else {
    if (val) {
      return _items?.value.find(
        (x) => x[itemValue.value] === val[itemValue.value]
      )?.[itemText.value]
    }
    else {
      return ""
    }

  }
};

const setText = () => {
  if (multiple.value) {
    modelText.value =
      _modelValue?.value.length > 0
        ? _modelValue?.value.map((x: any) => {
          return x;
        })
        : [];
  } else {
    var val = getText(_modelValue.value);
    modelText.value = val;

    if (val) {
      setTimeout(() => {
        selected.value = true;
      }, 100);
    }
  }
};

const removeSelected = (index: number) => {
  _list?.value.splice(index, 1);
};

const handleScroll = (e: any) => {
  let el = e.target;
  if (el.offsetHeight + el.scrollTop >= el.scrollHeight) {
    loadMore();
  }
};

const loadMore = () => {
  if (!((options.page - 1) * itemsPerPage.value <= options.totalItems)) {
    return;
  }

  if (options.page == 0) {
    serverItems.value = [];
  }

  if (isLoading.value) {
    loading.value = true;
  } else {
    loading.value = false;
  }

  clearTimeout(loadTimer.value);
  loadTimer.value = setTimeout(() => {
    var oldItems = serverItems.value.length <= 0 ? [] : serverItems.value;
    emit("load", {
      page: ++options.page,
      itemsPerPage: options.itemsPerPage,
      search: options.search,
      callback: (items: any[], tItems: number) => {
        serverItems.value = [...oldItems, ...items] || [];
        options.totalItems = tItems || 0;
        loading.value = false;
        setText();
      },
    });
  }, 1500);

  if (!isServerSideRendering.value) {
    loading.value = false;
    console.log('false', loading.value);
  }

  // nextTick(()=>{
  //   loading.value = false;
  // })
};

// defineExpose({
//   loadMore,
// });

watch(serverItems, (val, oldVal) => {
  if (!val || !val.length) {
    return;
  }

  if (!oldVal || !oldVal.length) {
    if (!_modelValue.value) {
      return;
    }

    if (!props.itemValue) {
      return;
    }

    const item = serverItems.value.find(x => x[props.itemValue] === _modelValue.value);
    if (!item) {
      return;
    }

    setValue(item)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_DropdownToggle = _resolveComponent("DropdownToggle")!
  const _component_DropdownHeader = _resolveComponent("DropdownHeader")!
  const _component_DropdownItem = _resolveComponent("DropdownItem")!
  const _component_DropdownContent = _resolveComponent("DropdownContent")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dropdown, {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((show).value = $event)),
      class: "inline-block w-full h-8 flex-1",
      style: _normalizeStyle(_unref(disabled)
      ? 'pointer-events: none; cursor: not-allowed;'
      : 'cursor: pointer;'
      )
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DropdownToggle, {
          class: "relative w-full",
          id: `clicked-${_unref(refKey)}`
        }, {
          default: _withCtx(() => [
            (!_unref(multiple))
              ? (_openBlock(), _createBlock(TextField, {
                  key: 0,
                  class: "w-full",
                  label: _unref(label),
                  tag: _unref(tag),
                  modelValue: modelText.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelText).value = $event)),
                  placeholder: _placeholder.value,
                  style: {"pointer-events":"none"},
                  icon: _icon,
                  rule: _unref(rule),
                  isClear: false,
                  disabled: _unref(disabled),
                  loading: loading.value
                }, {
                  loadingBar: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["label", "tag", "modelValue", "placeholder", "rule", "disabled", "loading"]))
              : (_openBlock(), _createBlock(MultipleSelect, {
                  key: 1,
                  modelText: modelText.value,
                  "onUpdate:modelText": _cache[1] || (_cache[1] = ($event: any) => ((modelText).value = $event)),
                  label: _unref(label),
                  placeholder: _placeholder.value,
                  tag: _unref(tag),
                  rule: _unref(rule),
                  disabled: _unref(disabled),
                  itemText: _unref(itemText),
                  isObject: _unref(resultObj),
                  icon: _icon,
                  onRemoveSelected: _cache[2] || (_cache[2] = ($event: any) => (removeSelected($event))),
                  loading: loading.value
                }, {
                  loadingBar: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["modelText", "label", "placeholder", "tag", "rule", "disabled", "itemText", "isObject", "loading"]))
          ]),
          _: 1
        }, 8, ["id"]),
        _createVNode(_component_DropdownMenu, { class: "w-full px-1" }, {
          default: _withCtx(() => [
            _createVNode(_component_DropdownContent, null, {
              default: _withCtx(() => [
                _createVNode(_component_DropdownHeader, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(TextField, {
                        class: "w-full",
                        modelValue: search.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search).value = $event)),
                        placeholder: "Search....",
                        isClear: false,
                        ref_key: "focusSearchRef",
                        ref: focusSearchRef
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }),
                (_items.value && _items.value?.length > 0 && !_unref(header)?.length)
                  ? (_openBlock(), _createBlock(_component_DropdownContent, {
                      key: 0,
                      style: _normalizeStyle(`max-height: ${_unref(itemsPerPage) * 20
            }px; overflow: scroll;padding:0px; margin: 0px;`),
                      onScroll: handleScroll
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_items.value, (item, i) => {
                          return (_openBlock(), _createBlock(_component_DropdownItem, {
                            key: i,
                            onClick: ($event: any) => (select(item))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item[_unref(itemText)]), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["style"]))
                  : _createCommentVNode("", true),
                (_items.value && _items.value.length > 0 && _unref(header).length > 0)
                  ? (_openBlock(), _createBlock(_component_DropdownContent, {
                      key: 1,
                      style: _normalizeStyle(`max-height: ${_unref(itemsPerPage) * 20}px; overflow: scroll`),
                      onScroll: handleScroll
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("table", _hoisted_5, [
                          _createElementVNode("thead", _hoisted_6, [
                            _createElementVNode("tr", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(header), (head, i) => {
                                return (_openBlock(), _createElementBlock("th", {
                                  class: "whitespace-nowrap uppercase",
                                  key: i
                                }, _toDisplayString(head.text), 1))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_items.value, (item, i) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: i,
                                class: _normalizeClass(`intro-x cursor-pointer bg-${item?.tableColor ? item?.tableColor : 'inherit'
                  }`),
                                onClick: ($event: any) => (select(item))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(header), (head, index) => {
                                  return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(head.format
                        ? head.format(item[head.value])
                        : item[head.value]), 1))
                                }), 128))
                              ], 10, _hoisted_7))
                            }), 128))
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["style"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_DropdownContent, { class: "text-center" }, {
                  default: _withCtx(() => [
                    ((!_items.value || _items.value.length <= 0) && !isSearch.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("No data")
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (loading.value)
                  ? (_openBlock(), _createBlock(_component_DropdownContent, {
                      key: 2,
                      class: "w-10 h-10 flex justify-center items-center space-x-1"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _hoisted_9
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "style"]),
    (_unref(header).length > 0 && _unref(infoEnable))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_headerData.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", null, _toDisplayString(item.text) + " : " + _toDisplayString(item.format ? item.format(item.value) : item.value), 1)
            ]))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})